
import React from 'react';

interface HeroProps {
  onOpenQuote: () => void;
  onOpenPortal: () => void;
}

const Hero: React.FC<HeroProps> = ({ onOpenQuote, onOpenPortal }) => {
  const scrollToJourney = () => {
    const element = document.getElementById('journey');
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="relative min-h-[95vh] flex items-center pt-20 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-1/4 h-full bg-red-50 -skew-x-12 transform translate-x-1/2 -z-10 opacity-30"></div>
      <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-red-600 rounded-full opacity-5 -z-10"></div>
      
      {/* Animated Path Illustration (Mobile Hidden) */}
      <div className="absolute top-1/2 right-20 -translate-y-1/2 hidden xl:block pointer-events-none">
        <svg width="400" height="400" viewBox="0 0 400 400" className="opacity-10">
          <circle cx="200" cy="200" r="180" stroke="#dc2626" strokeWidth="1" fill="none" strokeDasharray="10 10" className="animate-spin-slow" />
          <path d="M100,200 Q200,100 300,200 T100,200" stroke="#dc2626" strokeWidth="2" fill="none" className="animate-pulse" />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-10 animate-fadeIn">
          <div>
            <h1 className="text-6xl md:text-8xl font-black text-gray-900 leading-[1] tracking-tighter">
              Multi-Continents. <br />
              <span className="text-red-600 italic">One Seamless</span> Corridor.
            </h1>
          </div>
          
          <p className="text-xl md:text-2xl text-gray-600 leading-relaxed max-w-2xl mx-auto font-medium">
            KommtFlix is your gateway for trading, sourcing and procurement between Europe and Africa. Bridging markets with premium quality product and service.
          </p>
          
          {/* Centered Stats Section */}
          <div className="flex flex-row items-stretch justify-center pt-16 border-t border-gray-50 max-w-2xl mx-auto">
            <div className="flex-1 text-center px-4">
              <p className="text-4xl font-black text-gray-900 tracking-tight">40+</p>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Target Economies</p>
            </div>
            
            <div className="w-px bg-gray-100 self-center h-12"></div>
            
            <div className="flex-1 text-center px-4 relative">
              <p className="text-4xl font-black text-gray-900 tracking-tight">24h</p>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Response Time</p>
            </div>
            
            <div className="w-px bg-gray-100 self-center h-12"></div>
            
            <div className="flex-1 text-center px-4">
              <p className="text-4xl font-black text-gray-900 tracking-tight">00%</p>
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-2">Export VAT Policy</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
